import { Badge, Button } from "antd";
import { Header } from "antd/es/layout/layout";
import { MenuOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import ProfilePage from "../ProfileIcon";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "@store/hooks";

function TopHeader(props: any) {
  const { collapsed, setCollapsed } = props;
  const navigate = useNavigate();
  const token = useAppSelector((state) => state.auth.token);
  const user = useAppSelector((state) => state.auth.user);
  const itemCount = useAppSelector((state) => state.cart.itemCount);
  const role = user?.role;
  const hello = token ? user?.first_name || (role === "store" ? "Store" : role === "admin" || role === "superadmin" ? "Superadmin" : "there") : "guest";
  const accountLine = token
    ? role === "store"
      ? "Store account"
      : role === "admin" || role === "superadmin"
        ? "Superadmin"
        : "Your account"
    : "Sign in";

  return (
    <Header className="store-header">
      <Button
        type="text"
        icon={<MenuOutlined />}
        onClick={() => setCollapsed(!collapsed)}
        className="store-menu-btn"
      />
      <div className="store-header-actions">
        <button
          type="button"
          className="account-chip"
          onClick={() => navigate(token ? "/accounts" : "/login")}
        >
          <span>Hello, {hello}</span>
          <strong>{accountLine}</strong>
        </button>
        <Badge count={itemCount} showZero={false} color="#1c1917">
          <Button className="cart-chip" icon={<ShoppingCartOutlined />} onClick={() => navigate("/cart")}>
            Cart
          </Button>
        </Badge>
        {token ? <ProfilePage /> : null}
      </div>
    </Header>
  );
}

export default TopHeader;
